import { FormControl } from '@angular/forms';
import { ReplaySubject, Subject, takeUntil } from 'rxjs';
import { BdUiSingleSelectConfig } from './single-select.config';

export abstract class BdAbstractSingleSelect<
  TOption,
  TWrapperOption,
  TAllOptions = TWrapperOption,
> {
  public valid = true;
  public searching = true;
  public selectCtrl: FormControl<TWrapperOption | null> = new FormControl();

  public placeholderLabel: string;
  public noEntriesFoundLabel: string;
  public errorMessage: string;
  public allOptions: Subject<TAllOptions[]> = new ReplaySubject<TAllOptions[]>(
    1,
  );
  protected _onDestroy = new Subject<void>();

  protected init(config: BdUiSingleSelectConfig<TOption>): void {
    this.placeholderLabel = `${config.selectLabel} suchen`;
    this.noEntriesFoundLabel = `Keine ${config.selectLabel} gefunden`;

    this.selectCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.onSelectionChange(this.selectCtrl.value);
      });

    if (config.valid$) {
      config.valid$.pipe(takeUntil(this._onDestroy)).subscribe((valid) => {
        this.valid = valid.isValid;
        this.errorMessage = valid.isValid ? null : (valid.errorMessage ?? '');
      });
    }
  }

  protected setSelection(
    selection: TWrapperOption,
    options?: {
      onlySelf?: boolean;
      emitEvent?: boolean;
      emitModelToViewChange?: boolean;
      emitViewToModelChange?: boolean;
    },
  ): void {
    this.selectCtrl.setValue(selection, options);
  }

  protected abstract onSelectionChange(selection: TWrapperOption | null): void;

  protected abstract transformToWrapper(option: TOption): TWrapperOption;
}
